import React from "react";
import TextInput from "../../form/TextInput";

export default class CashRepositoryForm extends React.Component {
    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="name" value={this.props.values.name} label="Név" {...this.props.getFieldProps("name")} saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextInput name="document_prefix" value={this.props.values.document_prefix} label="Prefix" {...this.props.getFieldProps("document_prefix")} saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>
            </form>
        );
    }
}